{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password",
      "ERROR": "Password is too short."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Passwords do not match."
    },
    "API": {
      "SUCCESS_MESSAGE": "Successfully changed the password.",
      "ERROR_MESSAGE": "Could not connect to Woot Server, Please try again later"
    },
    "CAPTCHA": {
      "ERROR": "Verification expired. Please solve captcha again."
    },
    "SUBMIT": "Submit"
  }
}
